import { Dispatch, SetStateAction } from "react";
import { omitBy, isNil } from "lodash";

import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { ITaskEventTracker } from "../../shared/db";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_DELETE_TASK_EVENT_TRACKER } from "../state";
import { getToken } from "./token_fetcher";
import { getTaskEventTrackerSchemaMap } from "../../model/event_tracker";

export const REQUEST_TASK_EVENT_TRACKER_DELETE = "REQUEST_TASK_EVENT_TRACKER_DELETE";
export const doREQUEST_TASK_EVENT_TRACKER_DELETE = createDoRequestAction(
  REQUEST_TASK_EVENT_TRACKER_DELETE,
);

export const requestTaskEventTrackerDeleteActionCreators = {
  doREQUEST_TASK_EVENT_TRACKER_DELETE,
};

interface Payload {
  payload: {
    requestId: string;
    eventTracker: Pick<ITaskEventTracker, "id">;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestTaskEventTrackerDelete({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestTaskEventTrackerDelete");

  payload.eventTracker = omitBy(payload.eventTracker, isNil) as Payload["payload"]["eventTracker"];

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        eventTracker: v.object(getTaskEventTrackerSchemaMap({ required: ["id"] })),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);

  const { eventTracker } = payload;

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/task-event-tracker-delete`,
    accessToken,
    data: eventTracker,
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/task-event-tracker-delete",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doMETHOD_DELETE_TASK_EVENT_TRACKER(eventTracker));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_EVENT_TRACKER_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskEventTrackerDeleteSaga() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yield takeEvery(REQUEST_TASK_EVENT_TRACKER_DELETE as any, requestTaskEventTrackerDelete);
}
